<template>
  <qx-card title="订单详情">
    <section class="detail-item-title">
      <div class="detail-item-title-l">
        <span>订单：</span>
        <span>{{ orderDetail.base && orderDetail.base.orderId }}</span>
      </div>
    </section>
    <qx-detail-box :data="detailData.base">
      <section slot="lineName" slot-scope="prop">
        <section>
<!--          <template-->
<!--              v-if="prop.data.lineId !== null && prop.data.lineId > 0"-->
<!--          >-->
<!--            <span>{{ prop.data.lineId }}</span>-->
<!--          </template>-->
          <template
              v-if="prop.data.lineId == null || prop.data.lineId <= 0"
          >
            <span>无（临时线路）</span>
          </template>
          <span>{{ ' ' + prop.data.lineName }}</span>
        </section>
        <section
            class="error"
            v-if="
            orderDetail.baseVer &&
            prop.data.sourceCode !== orderDetail.baseVer.sourceCode
          "
        >
          修改为：
          <span>{{ orderDetail.baseVer.sourceCode || '无（临时线路）' }}</span>
          <span>{{ ' ' + orderDetail.baseVer.lineName }}</span>
        </section>
      </section>

      <section slot="lineDetail">
        <LineDetail :lineDetail="lineDetail" />
      </section>

      <section slot="carriageDetail">
        <DetailItem
            :detailItemList="carriageDetailItemList"
            :orderDetail="orderDetail"
            propName="carriageDetail"
        />
      </section>

      <section slot="incomeDetail">
        <DetailItem
            :detailItemList="incomeDetailItemList"
            :orderDetail="orderDetail"
            propName="incomeDetail"
        />
      </section>

    </qx-detail-box>
  </qx-card>
</template>

<script>
import DetailItem from './components/detailItem';
import LineDetail from 'components/lineDetail/lineDetail';
export default {
  components: {
    DetailItem,
    LineDetail,
  },
  data () {
    return {
      orderDetail: {},
      lineDetail: {},
      // 需要审核的城市配送卸货点列表
      cityCustomerOrderVers: {},
      carriageDetailItemList: [
        { label: '货品名称', value: 'productName' },
      ],
      incomeDetailItemList: [
        { label: '收入金额', value: 'costPrice' },
        { label: '收入单价', value: 'priceUnit' },
      ],
      detailData: {
        base: {
          label: '',
          tableData: {
            title: [
              // { prop: 'opName', label: '录入人员' },
              { prop: 'lineName', label: '线路', slot: true },
              { prop: 'customerName', label: '客户名称' },
              { prop: 'customerNumber', label: '客户单号' },
              { prop: 'carriageDetail', label: '运货信息', slot: true, span: 1 },
              { prop: 'incomeDetail', label: '收入信息', slot: true, span: 1 },
            ],
            data: {
            },
            approveData: {
            },
          },
        },
      },
    };
  },
  computed: {
    colSpan () {
      const total = 24;
      const minSpan = 4;
      return parseInt(total / this.orderInfo.length, 10) < minSpan ? minSpan : parseInt(total / this.orderInfo.length, 10);
    },
  },
  methods: {
    // 详情数据（用来展示）
    setBaseData (detailRes) {
      // 录入人员 和时间
      // const opName = `${detailRes.updateBy}${orderInfo.createDate ? (' / ' + orderInfo.createDate.substring(2, 16)) : '--'}`;

      let insertArr = [];
      insertArr = [
        { prop: 'lineDetail', label: '线路信息', slot: true, span: 1, lableHide: true },
      ];

      const insertStartIndex = this.detailData.base.tableData.title.findIndex((item) => item.prop === 'customerNumber') + 1;
      const insertEndIndex = this.detailData.base.tableData.title.findIndex((item) => item.prop === 'customerDetail');
      this.detailData.base.tableData.title.splice(insertStartIndex, insertEndIndex - insertStartIndex, ...insertArr);
      let orderDetail = detailRes.dZOrderListOut == null ? detailRes.dZDriverOrderInfo : detailRes.dZOrderListOut;
      this.orderDetail.base = {
        orderId: orderDetail.orderId,
        lineId: orderDetail.lineId, // 线路名称
        lineName: orderDetail.lineName, // 线路名称
        customerName: orderDetail.customerName, // 客户名称
        customerNumber: orderDetail.customerNumber, // 客户单号

        lineDetail: this.getLineDetailData(detailRes),
        carriageDetail: this.getCarriageDetailData(detailRes),
        incomeDetail: this.getIncomeDetailData(detailRes),
        // sourceFlag: orderInfo.sourceFlag,
        // source: orderGoods.source,
      };

      // 将对应模块的 详情数据 赋给 data 即可展示在页面上展示
      this.detailData.base.tableData.data = this.orderDetail.base;
    },
    // 审核数据（用来和 详情数据 做对比，如果和 详情数据不一样，则提示）
    setBaseVerData (detailRes) {
      const orderGoods = detailRes.orderGoodsVer;
      const orderScheduler = detailRes.orderSchedulerVer;
      const orderFee = detailRes.orderFeeVer;
      const incomePaymentDaysInfo = detailRes.incomePaymentDaysInfoVer || {};
      const transitLineInfos = detailRes.transitLineInfoVers || [];
      const isLineChange = this.compareLineDetailData(detailRes);
      const orderTrailer = detailRes.orderTrailerVer;

      this.orderDetail.baseVer = {
        orderId: this.orderDetail.base.orderId, // 不用对比
        opName: this.orderDetail.base.opName, // 不用对比
        sourceId: orderScheduler.sourceId,
        sourceCode: orderScheduler.sourceCode,
        sourceName: orderScheduler.sourceName,
        companyName: orderGoods.companyName,
        dependTime: orderScheduler.dependTime,
        orderStateName: this.orderDetail.base.orderStateName, // 不用对比
        lineDetail: this.getLineDetailData(orderScheduler, orderGoods, transitLineInfos),
        // customerDetail: this.getCustomerDetailData(orderScheduler, orderGoods),
        carriageDetail: this.getCarriageDetailData(orderTrailer, orderScheduler, orderGoods),
        incomeDetail: this.getIncomeDetailData(orderScheduler, orderFee, incomePaymentDaysInfo),
        isLineChange,
      };

      // 将对应模块的 审核数据 赋给 approveData 即可自动做对比
      this.detailData.base.tableData.approveData = this.orderDetail.baseVer;
    },
    // 对比线路数据是否有修改，主要对比 起点终点 以及 途经点 的经纬度
    compareLineDetailData (detailRes) {
      let isChange = false;
      // 对比 起点终点 的经纬度
      if (detailRes.orderGoods && detailRes.orderGoodsVer) {
        if (
          (detailRes.orderGoods.nand !== detailRes.orderGoodsVer.nand) ||
            (detailRes.orderGoods.eand !== detailRes.orderGoodsVer.eand) ||
            (detailRes.orderGoods.nandDes !== detailRes.orderGoodsVer.nandDes) ||
            (detailRes.orderGoods.eandDes !== detailRes.orderGoodsVer.eandDes)
        ) {
          isChange = true;
        }
      }
      // 只对比 途经点 的经纬度，其他应该不需要对比，我猜的
      if (
        (detailRes.transitLineInfos && detailRes.transitLineInfos.length) && (detailRes.transitLineInfoVers && detailRes.transitLineInfoVers.length)
      ) {
        const arr1 = detailRes.transitLineInfos.map((item) => ({
          nand: item.nand,
          eand: item.eand,
        }));
        const arr2 = detailRes.transitLineInfoVers.map((item) => ({
          nand: item.nand,
          eand: item.eand,
        }));
        if (JSON.stringify(arr1) !== JSON.stringify(arr2)) {
          isChange = true;
        }
      }
      return isChange;
    },
    getLineDetailData (detailRes) {
      let orderDetail = detailRes.dZOrderListOut == null ? detailRes.dZDriverOrderInfo : detailRes.dZOrderListOut;
      const addrDtl = orderDetail.source ? orderDetail.source.replace(/NaN|undefined|null/g, '') : '';
      const desDtl = orderDetail.des ? orderDetail.des.replace(/NaN|undefined|null/g, '') : '';
      return {
        sourceInfo: {
          addrDtl,
        },
        desInfo: {
          desDtl,
          // arriveTime: orderScheduler.arriveTime,
        },
        // transitLineInfos,
      };

    },
    // 运货信息
    getCarriageDetailData (detailRes) {
      let orderDetail = detailRes.dZOrderListOut == null ? detailRes.dZDriverOrderInfo : detailRes.dZOrderListOut;
      return {
        productName: orderDetail.productName,
      };
    },
    // 收入信息
    getIncomeDetailData (detailRes) {
      let orderDetail = detailRes.dZOrderListOut == null ? detailRes.dZDriverOrderInfo : detailRes.dZOrderListOut;
      const incomeDetail = {
        costPrice: orderDetail.incomeUnitPriceDouble + '元',
        priceUnit: orderDetail.incomeUnitPriceDouble + '元',
      };

      return incomeDetail;
    },
    setLineDetail (detailRes) {
      // const orderInfo = detailRes.orderInfo || {};
      // const orderGoods = detailRes.orderGoods || {};
      // const orderScheduler = detailRes.orderScheduler || {};
      // const orderGoodsVer = detailRes.orderGoodsVer || {};
      // const orderSchedulerVer = detailRes.orderSchedulerVer || {};
      // const subWayList = [];
      // const subWayListVer = [];

      // if (detailRes.transitLineInfos && detailRes.transitLineInfos.length) {
      //   for (let item of detailRes.transitLineInfos) {
      //     subWayList.push({
      //       desAddress: item.address,
      //       navigatDesLocation: item.navigatLocation,
      //       arriveTime: item.arriveTime,
      //       nand: item.nand,
      //       eand: item.eand,
      //     });
      //   }
      // }
      // if (detailRes.transitLineInfosVer && detailRes.transitLineInfosVer.length) {
      //   for (let item of detailRes.transitLineInfosVer) {
      //     subWayListVer.push({
      //       desAddress: item.address,
      //       navigatDesLocation: item.navigatLocation,
      //       arriveTime: item.arriveTime,
      //       nand: item.nand,
      //       eand: item.eand,
      //     });
      //   }
      // }
      let orderDetail = detailRes.dZOrderListOut == null ? detailRes.dZDriverOrderInfo : detailRes.dZOrderListOut;
      const lineDetail = {
        data: {
          // 出发导航地址
          navigatSourceLocation: orderDetail.source,
          // 出发地址
          source: orderDetail.source,
          // 目的导航地址
          navigatDesLocation: orderDetail.des,
          // 目的地址
          desAddress: orderDetail.des,
          // 到达时间
          // arriveTime: orderScheduler.arriveTime,
          // 途径地址
          // subWayList: subWayList,

          // 出发地经度
          nand: orderDetail.nandSource,
          // 出发地纬度
          eand: orderDetail.eandSource,
          // 目的地地经度
          nandDes: orderDetail.nandDes,
          // 目的地纬度
          eandDes: orderDetail.eandDes,
        },
        // ver: {
        //   // 出发导航地址（审核）
        //   navigatSourceLocation: orderGoodsVer.navigatSourceLocation || '',
        //   // 出发地址（审核）
        //   source: orderGoodsVer.source || '',
        //   // 目的导航地址（审核）
        //   navigatDesLocation: orderGoodsVer.navigatDesLocation || '',
        //   // 目的地址（审核）
        //   desAddress: orderGoodsVer.desDtl || '',
        //   // 到达时间
        //   arriveTime: orderSchedulerVer.arriveTime || '',
        //   // 途径地址（审核）
        //   subWayList: subWayListVer,
        //
        //   // 出发地经度
        //   nand: orderGoodsVer.nand,
        //   // 出发地纬度
        //   eand: orderGoodsVer.eand,
        //   // 目的地地经度
        //   nandDes: orderGoodsVer.nandDes,
        //   // 目的地纬度
        //   eandDes: orderGoodsVer.eandDes,
        // },

      };
      return lineDetail;
    },
    async getData (detailRes) {
      // 详情数据
      this.orderDetail = {};
      this.lineDetail = {};
      // 重写各个模块的 详情数据，方便和 审核数据 做对比
      this.setBaseData(detailRes);
      // if (this.$route.query.type === 'approve' && detailRes && detailRes.orderInfo.orderUpdateState === 2) {
      //   // 重写各个模块的 审核数据
      //   this.setBaseVerData(detailRes);
      // }
      this.lineDetail = this.setLineDetail(detailRes);
    },
  },
};
</script>

<style lang="scss" scoped>
.detail-item-inline-box {
  display: flex;
  justify-content: space-between;
  .detail-item-horizontal {
    width: 25%;
    border-right: 1px solid #e0e0e0;
    padding: 0 8px 0 24px;
    &:first-child {
      padding-left: 0;
    }
    &:last-child {
      border-right: none;
    }
  }
}
.detail-item-title {
  display: flex;
  justify-content: space-between;
  padding-top: 12px;
  padding-bottom: 12px;
  font-size: 18px;
  font-weight: 400;
}
</style>

